import { useState } from 'react';
import { usePreferenciasContext } from '../contexts/PreferenciasContext';

export default function ThemeConfiguration() {
  const [salvandoTema, setSalvandoTema] = useState(false);
  
  // Usar o contexto de preferências
  const {
    preferencias,
    carregando: carregandoPreferencias,
    erro: erroPreferencias,
    salvarPreferencia
  } = usePreferenciasContext();

  const handleSalvarPreferencia = async (campo: string, valor: any) => {
    try {
      setSalvandoTema(true);
      
      console.log('[ThemeConfiguration] Salvando preferência IMEDIATAMENTE:', {
        campo,
        valor,
        timestamp: new Date().toISOString()
      });

      // Salvar preferência no servidor E aplicar imediatamente
      const sucesso = await salvarPreferencia(campo as any, valor);
      
      if (sucesso) {
        console.log('[ThemeConfiguration] ✅ Preferência salva com sucesso:', {
          campo,
          valor,
          timestamp: new Date().toISOString()
        });
        
        // O Context já aplica o tema automaticamente no salvarPreferencia
        // Não precisamos fazer nada extra aqui
        
      } else {
        console.error('[ThemeConfiguration] ❌ Falha ao salvar preferência');
      }
    } catch (error) {
      console.error('[ThemeConfiguration] ❌ Erro ao salvar preferência:', error);
    } finally {
      setSalvandoTema(false);
    }
  };

  if (carregandoPreferencias) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3"></div>
          <p>Carregando preferências...</p>
        </div>
      </div>
    );
  }

  if (erroPreferencias) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-triangle mr-2"></i>
        <strong>Erro ao carregar preferências:</strong> {erroPreferencias}
      </div>
    );
  }

  if (!preferencias) {
    return (
      <div className="alert alert-warning">
        <i className="fas fa-info-circle mr-2"></i>
        <strong>Aviso:</strong> Preferências não disponíveis no momento.
      </div>
    );
  }

  // CSS dinâmico para temas
  const dynamicStyles = `
    <style id="theme-config-styles">
      .preview-card {
        transition: all 0.3s ease;
        border-radius: 8px;
        padding: 15px;
        margin: 10px 0;
        border: 1px solid ${preferencias.dark_mode ? '#495057' : 'rgba(0, 0, 0, 0.125)'};
        background: ${preferencias.dark_mode ? '#343a40' : '#fff'};
      }
      
      .preview-item {
        border: 1px solid ${preferencias.dark_mode ? '#495057' : '#dee2e6'};
        border-radius: 6px;
        padding: 8px;
        background: ${preferencias.dark_mode ? '#343a40' : '#fff'};
      }
      
      ${preferencias.dark_mode ? `
        body.dark-mode .custom-control-label::before {
          background-color: #495057 !important;
          border-color: #6c757d !important;
        }
        body.dark-mode .custom-control-input:checked ~ .custom-control-label::before {
          background-color: #007bff !important;
          border-color: #007bff !important;
        }
      ` : ''}
    </style>
  `;

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: dynamicStyles }} />
      
      <div className="row">
        <div className="col-md-6">
          <div className="card card-primary card-outline">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-cog mr-2"></i>
                Layout e Aparência
              </h3>
            </div>
            <div className="card-body">
              {/* Dark Mode - Switch AdminLTE Style */}
              <div className="form-group">
                <div className="form-label">
                  <i className="fas fa-moon mr-2"></i>
                  Modo Escuro
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="darkModeSwitch"
                    checked={preferencias.dark_mode}
                    onChange={(e) => handleSalvarPreferencia('dark_mode', e.target.checked)}
                    disabled={salvandoTema}
                  />
                  <label className="custom-control-label" htmlFor="darkModeSwitch">
                    {preferencias.dark_mode ? 'Ativado' : 'Desativado'}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Alterna entre tema claro e escuro
                </small>
              </div>

              {/* Configuração do Sidebar - OCULTO TEMPORARIAMENTE */}
              {/* 
              <div className="form-group">
                <label className="form-label">
                  <i className="fas fa-bars mr-2"></i>
                  Comportamento do Menu Lateral
                </label>
                <select
                  className="form-control select2"
                  value={preferencias.sidebar_mini ? 'mini' : preferencias.sidebar_recolhido ? 'recolhido' : 'expandido'}
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor === 'mini') {
                      handleSalvarPreferencia('sidebar_mini', true);
                      setTimeout(() => handleSalvarPreferencia('sidebar_recolhido', false), 50);
                    } else if (valor === 'recolhido') {
                      handleSalvarPreferencia('sidebar_mini', false);
                      setTimeout(() => handleSalvarPreferencia('sidebar_recolhido', true), 50);
                    } else {
                      handleSalvarPreferencia('sidebar_mini', false);
                      setTimeout(() => handleSalvarPreferencia('sidebar_recolhido', false), 50);
                    }
                  }}
                  disabled={salvandoTema}
                >
                  <option value="expandido">📖 Sempre Expandido</option>
                  <option value="recolhido">📑 Recolhido (Oculto por padrão)</option>
                  <option value="mini">📋 Mini (Ícones apenas, expande ao passar mouse)</option>
                </select>
                <small className="form-text text-muted">
                  Define como o menu lateral se comporta
                </small>
              </div>
              */}

              {/* Layout Fixo - Switch AdminLTE Style */}
              <div className="form-group">
                <div className="form-label">
                  <i className="fas fa-thumbtack mr-2"></i>
                  Layout Fixo
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="layoutFixoSwitch"
                    checked={preferencias.layout_fixo}
                    onChange={(e) => handleSalvarPreferencia('layout_fixo', e.target.checked)}
                    disabled={salvandoTema}
                  />
                  <label className="custom-control-label" htmlFor="layoutFixoSwitch">
                    {preferencias.layout_fixo ? 'Fixo' : 'Flutuante'}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Fixa o layout na tela durante rolagem
                </small>
              </div>

              {/* Navbar Fixa - Switch AdminLTE Style */}
              <div className="form-group">
                <div className="form-label">
                  <i className="fas fa-window-maximize mr-2"></i>
                  Navbar Fixa
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="navbarFixaSwitch"
                    checked={preferencias.navbar_fixo}
                    onChange={(e) => handleSalvarPreferencia('navbar_fixo', e.target.checked)}
                    disabled={salvandoTema}
                  />
                  <label className="custom-control-label" htmlFor="navbarFixaSwitch">
                    {preferencias.navbar_fixo ? 'Fixa no topo' : 'Rolagem livre'}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Mantém a barra de navegação sempre visível
                </small>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="card card-info card-outline">
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-font mr-2"></i>
                Tipografia
              </h3>
            </div>
            <div className="card-body">
              {/* Tamanho da Fonte - Select AdminLTE Style (SEM PREVIEW) */}
              <div className="form-group">
                <label className="form-label" htmlFor="tamanhoFonteSelect">
                  <i className="fas fa-text-height mr-2"></i>
                  Tamanho da Fonte
                </label>
                <select
                  id="tamanhoFonteSelect"
                  className="form-control select2"
                  value={preferencias.tamanho_fonte}
                  onChange={(e) => handleSalvarPreferencia('tamanho_fonte', e.target.value)}
                  disabled={salvandoTema}
                >
                  <option value="pequeno">📏 Pequeno (14px)</option>
                  <option value="medio">📐 Médio (16px)</option>
                  <option value="grande">📏 Grande (18px)</option>
                </select>
                <small className="form-text text-muted">
                  Ajusta o tamanho do texto em toda a interface
                </small>
              </div>

              {/* Família da Fonte - Select AdminLTE Style (SEM PREVIEW) */}
              <div className="form-group">
                <label className="form-label" htmlFor="familiaFonteSelect">
                  <i className="fas fa-font mr-2"></i>
                  Família da Fonte
                </label>
                <select
                  id="familiaFonteSelect"
                  className="form-control select2"
                  value={preferencias.fonte_familia || 'Source Sans Pro'}
                  onChange={(e) => handleSalvarPreferencia('fonte_familia', e.target.value)}
                  disabled={salvandoTema}
                >
                  <option value="Source Sans Pro">Source Sans Pro (Padrão)</option>
                  <option value="Inter">Inter (Moderna)</option>
                  <option value="Roboto">Roboto (Google)</option>
                  <option value="Open Sans">Open Sans (Legível)</option>
                  <option value="Lato">Lato (Elegante)</option>
                  <option value="Nunito">Nunito (Amigável)</option>
                  <option value="Poppins">Poppins (Geométrica)</option>
                  <option value="Montserrat">Montserrat (Urbana)</option>
                  <option value="Arial">Arial (Sistema)</option>
                  <option value="Helvetica Neue">Helvetica Neue (Apple)</option>
                </select>
                <small className="form-text text-muted">
                  Define a fonte utilizada em toda a interface
                </small>
              </div>

              {/* Animações - Switch AdminLTE Style */}
              <div className="form-group">
                <div className="form-label">
                  <i className="fas fa-magic mr-2"></i>
                  Animações
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="animacoesSwitch"
                    checked={preferencias.animacoes_habilitadas}
                    onChange={(e) => handleSalvarPreferencia('animacoes_habilitadas', e.target.checked)}
                    disabled={salvandoTema}
                  />
                  <label className="custom-control-label" htmlFor="animacoesSwitch">
                    {preferencias.animacoes_habilitadas ? 'Habilitadas' : 'Desabilitadas'}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Controla efeitos de transição e animações
                </small>
              </div>

              {/* Sombras - Switch AdminLTE Style */}
              <div className="form-group">
                <div className="form-label">
                  <i className="fas fa-shapes mr-2"></i>
                  Sombras nos Cards
                </div>
                <div className="custom-control custom-switch">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="sombrasSwitch"
                    checked={preferencias.sombras_habilitadas}
                    onChange={(e) => handleSalvarPreferencia('sombras_habilitadas', e.target.checked)}
                    disabled={salvandoTema}
                  />
                  <label className="custom-control-label" htmlFor="sombrasSwitch">
                    {preferencias.sombras_habilitadas ? 'Habilitadas' : 'Desabilitadas'}
                  </label>
                </div>
                <small className="form-text text-muted">
                  Adiciona profundidade visual aos cards
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
